import { render, staticRenderFns } from "./PreviewPlayer.vue?vue&type=template&id=6b8a2448&"
import script from "./PreviewPlayer.vue?vue&type=script&lang=js&"
export * from "./PreviewPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports